import { useEffect, useState } from 'react'
import { Company } from '../../../types/Controlling/Company'
import useLoadControllingCompanies from './useLoadControllingCompanies'

const useLoadControllingCompany = (uuid: string): Company | null => {
  const [companies] = useLoadControllingCompanies()
  const [company, setCompany] = useState<Company>(null)

  useEffect(() => {
    if (!company && !!companies && !!uuid) {
      const company = companies.find((c) => c.uuid === uuid)
      if (!!company) {
        setCompany(company)
      }
    }
  }, [companies, uuid, company])

  return company
}

export default useLoadControllingCompany
